import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NgxLoopVehicleLiveMap, VehicleMap} from '../ngx-loop-vehicle-livemap/ngx-loop-vehicle-livemap';
import {MatExpansionPanel, MatSlideToggleChange, MatTableDataSource} from '@angular/material';
import {ConfigurationService} from '../depends/configuration.service';
import {NgxTrackItPanel, TrackItPointExtras} from '../ngx-trackit-panel/ngx-track-it-panel.component';

interface IVehicleFilter {
    value: number;
    label: string;
    class: string;
}

export interface TrackItPeriodChangeEvent {
    begin: string,
    end: string,
    idVehicle: number
}

export interface ILoopVehiclesStatus {
    status: {
        unknown: any,
        available: any,
        working: {
            items: {
                [key: string]: any
            },
            loading: number,
            to_job: number,
            on_job: number,
            to_plant: number,
        }
    };
    trips_calculator_id: number;
    plant_calculator_id: number;
    unavailable_status: any;
}

export const VEHICLES_STATUSES = {
    TO_JOB: {
        label: 'label.going',
        field: 'to_job',
        color: 'var(--to-job-color)',
        icon: 'mdi-truck-fast-outline',
        customIcon: 'default.png'
    },
    ON_JOB: {
        label: 'label.atSite',
        field: 'on_job',
        color: 'var(--on-job-color)',
        icon: 'mdi-map-marker-radius',
        customIcon: 'default.png'
    },
    TO_PLANT: {
        label: 'label.returning',
        field: 'to_plant',
        color: 'var(--to-plant-color)',
        icon: 'mdi-truck-fast-outline mdi-flip-h',
        customIcon: 'default.png'
    },
    LOADING: {
        label: 'label.loading',
        field: 'loading',
        color: 'var(--loading-color)',
        icon: 'mdi-download',
        customIcon: 'loading.gif'
    },
    DEFAULT: {
        label: '',
        color: 'var(--background-card)'
    }
};

const IGNITION_OFF = 0;
const IGNITION_ON = 1;
const IGNITION_ON_OFF = 2;

const NOT_IN_PLANT = 0;
const IN_PLANT = 1;
const PLANT_WITHOUT_FILTER = 2;

const IGNITION_ON_OFF_STATUS: IVehicleFilter = {
    value: IGNITION_ON_OFF,
    label: 'label.no_filter',
    class: 'foreground-default mdi-minus-circle-off-outline'
};

const IGNITION_OFF_STATUS: IVehicleFilter = {
    value: IGNITION_OFF,
    label: 'label.ignition_off',
    class: 'foreground-default mdi-minus-circle-outline'
};

const IGNITION_ON_STATUS: IVehicleFilter = {
    value: IGNITION_ON,
    label: 'label.ignition_on',
    class: 'red-signal mdi-minus-circle-outline'
};

const OUTSIDE_PLANT_STATUS: IVehicleFilter = {
    value: NOT_IN_PLANT,
    label: 'label.vehicle_not_in_plant',
    class: 'red-signal mdi-factory'
};

const IN_PLANT_STATUS: IVehicleFilter = {
    value: IN_PLANT,
    label: 'label.vehicle_in_plant',
    class: 'green-signal mdi-factory'
};

const INSIDE_OR_OUTSIDE_PLANT_STATUS: IVehicleFilter = {
    value: PLANT_WITHOUT_FILTER,
    label: 'label.no_filter',
    class: 'foreground-default mdi-factory'
};



export class VehicleMapGroup {

    dataSource: MatTableDataSource<VehicleMap> = new MatTableDataSource();
    indeterminateChecked: boolean = false;
    allVisible: boolean = true;
    panel: MatExpansionPanel;

    constructor(
        public vehicles: VehicleMap[],
        public keylangTitle: string,
        public idType: number
    ) {
        this.dataSource.data = this.vehicles;
    }

    setPanel(panel: MatExpansionPanel) {
        this.panel = panel;
    }

    isAllVisible(): boolean {
        for (let i = 0; i < this.vehicles.length; i++) {
            if (!this.vehicles[i].visible)
                return false;
        }
        return true;
    }

    setCheckState() {
        let total = 0;
        let total_checked = 0;
        let total_unchecked = 0;

        this.vehicles.forEach(v => {
            if (v.marker != null) {
                total += 1;
                total_checked += v.visible || v.marker == null ? 1 : 0;
                total_unchecked += !v.visible && v.marker ? 1 : 0;
            }
        });

        if (total_checked == total) {
            this.indeterminateChecked = false;
            this.allVisible = true;
        } else if (total_unchecked == total) {
            this.indeterminateChecked = false;
            this.allVisible = false;
        } else {
            this.allVisible = false;
            this.indeterminateChecked = true;
        }

        console.log(this.indeterminateChecked);
    }
}


@Component({
    selector: 'NgxLoopMapVehiclePanel',
    templateUrl: './ngx-loop-map-vehicle-panel.html',
    styleUrls: ['./ngx-loop-map-vehicle-panel.css']
})
export class NgxLoopMapVehiclePanel implements OnInit, AfterViewInit {

    @ViewChild('masterPanel', {static: false})
    masterPanel: MatExpansionPanel;

    // Is not a ViewChild because of NGIF, so we have a ref method that gets its reference
    // On component view init.

    trackItPanel: NgxTrackItPanel;

    vehicles: VehicleMap[] = [];

    groupsByType: VehicleMapGroup[] = [];

    @Input()
    liveMap: NgxLoopVehicleLiveMap;

    @Input() set setLoopVehiclesStatus(loopVehicleStatus: ILoopVehiclesStatus) {
        if (loopVehicleStatus != null) {
            this.loopVehicleStatus = loopVehicleStatus;
            if (this.vehicles && this.vehicles.length > 0) {
                this.updateVehiclesTooltip();
            }
        }
    }
    loopVehicleStatus: ILoopVehiclesStatus;

    @Input()
    showVehicleEditionButton: boolean = false;

    @Input()
    enableTrackTt: boolean = false;

    @Input()
    trackItAdditionalFields: { title: string, field: string }[] = [];

    @Output()
    onVehicleEditButtonClicked: EventEmitter<VehicleMap> = new EventEmitter<VehicleMap>();

    @Output()
    onVehiclesMapDoneBuilding: EventEmitter<VehicleMap[]> = new EventEmitter<VehicleMap[]>();

    @Output()
    onTrackItPeriodChanged: EventEmitter<TrackItPeriodChangeEvent> = new EventEmitter<TrackItPeriodChangeEvent>();

    trackItVehicle: VehicleMap = null;

    clustered: boolean = true;
    showNames: boolean = false;

    ignitionFilterResource: IVehicleFilter[] = [
        IGNITION_ON_OFF_STATUS,
        IGNITION_ON_STATUS,
        IGNITION_OFF_STATUS
    ];

    plantFilterResource: IVehicleFilter[] = [
        INSIDE_OR_OUTSIDE_PLANT_STATUS,
        IN_PLANT_STATUS,
        OUTSIDE_PLANT_STATUS,
    ];

    ignitionFilterValue: IVehicleFilter = IGNITION_ON_OFF_STATUS;
    plantFilterValue: IVehicleFilter = INSIDE_OR_OUTSIDE_PLANT_STATUS;

    filterText: string;


    constructor(
        private configurationService: ConfigurationService,
    ) {
        this.showNames = this.configurationService.getConfigValue('general', 'live_map_show_vehicle_name');
        this.clustered = this.configurationService.getConfigValue('general', 'live_map_vehicle_clustered');
    }

    ngOnInit() {
        console.log(this.ignitionFilterValue);
    }

    setTrackitPointExtras(extras: TrackItPointExtras[]) {
        if (this.trackItPanel) {
            this.trackItPanel.setPointExtras(extras);
        }
    }

    onVehicleDataChanged(vehicleId: number, name: string, iconName: string, typeId: number, typeKeylang: string) {

        let groupIndex = -1;
        let index = -1;
        let originalResource: VehicleMap;
        let newGroupIndex = -1;

        for (let i = 0; i < this.groupsByType.length; i++) {
            if (typeId == this.groupsByType[i].idType) {
                newGroupIndex = i;
                console.log("New group index", newGroupIndex);
            }
            for (let j = 0; j < this.groupsByType[i].vehicles.length; j++) {
                if (vehicleId == this.groupsByType[i].vehicles[j].vehicle.id) {
                    groupIndex = i;
                    index = j;
                    originalResource = this.groupsByType[i].vehicles[j];
                    console.log("Group Index", groupIndex);
                }
            }
        }

        originalResource.vehicle.name = name;
        originalResource.vehicle.icon = iconName;

        let marker = originalResource.marker;

        if (marker) {
            marker.setIcon(this.liveMap.getVehicleMarkerIcon(iconName));
            let tooltip = marker.getTooltip();
            if (tooltip != null) {
                marker.unbindTooltip();
                this.liveMap.bindToolTip(name, marker, 'vehicle-tooltip')
            }
        }

        if (newGroupIndex == -1) {
            this.groupsByType.push(new VehicleMapGroup([originalResource], typeKeylang, typeId));
            this.groupsByType[groupIndex].vehicles.splice(index, 1);
            this.groupsByType[groupIndex].dataSource._updateChangeSubscription();
            console.log("Creating new group");
        } else if (groupIndex != newGroupIndex) {

            this.groupsByType[newGroupIndex].vehicles.push(originalResource);
            // this.groupsByType[newGroupIndex].dataSource.data.push(originalResource);

            this.groupsByType[groupIndex].vehicles.splice(index, 1);
            this.groupsByType[groupIndex].dataSource.data.splice(index, 1);

            this.groupsByType[newGroupIndex].dataSource._updateChangeSubscription();
            this.groupsByType[groupIndex].dataSource._updateChangeSubscription();

            console.log("Moving resource");
            if (this.groupsByType[groupIndex].vehicles.length == 0) {
                console.log("Empty Group, removing");
                this.groupsByType.splice(groupIndex, 1);
            }
        }
    }

    onTrackItPressed(vehicleMap: VehicleMap) {
        this.liveMap.resetTrackingVehicle();
        this.trackItVehicle = vehicleMap;
        console.log("PRESSED");
    }

    toggleAllVehiclesVisibility() {
        this.liveMap.toggleAllVehiclesVisibility(this.clustered);
    }

    onNameModeChanged(event: MatSlideToggleChange) {
        this.showNames = event.checked;
        this.configurationService.updateConfiguration('general', ['live_map_show_vehicle_name'], [this.showNames]).then(() => {
        });
        this.setVehiclesTooltip();
    }

    setVehiclesTooltip() {
        this.vehicles.forEach(vm => {
            if (this.showNames) {
                this.liveMap.bindToolTip(vm.vehicle.name, vm.marker, 'vehicle-tooltip');
            } else {
                this.liveMap.unbindToolTip(vm);
            }
        });
    }

    updateVehiclesTooltip() {
        if (this.loopVehicleStatus != null) {
            this.vehicles.forEach(vm => {
                if (this.showNames) {
                    const vehicleStatusData = this.loopVehicleStatus.status.working.items[vm.vehicle.id];
                    if (vehicleStatusData != null) {
                        const newVehicleStatus: string = vehicleStatusData.status;

                        if (vm.status !== newVehicleStatus) {
                            this.setVehicleStatusAndColor(vm);
                            const className = this.getVehicleClass(vm);
                            this.liveMap.unbindToolTip(vm);
                            this.liveMap.bindToolTip(vm.vehicle.name, vm.marker, className);
                        }
                    } else {
                        const markerTooltip = vm.marker != null ? vm.marker.getTooltip() : null;

                        if (markerTooltip != null && markerTooltip.options.className !== 'vehicle-tooltip') {
                            this.liveMap.unbindToolTip(vm);
                            this.liveMap.bindToolTip(vm.vehicle.name, vm.marker, 'vehicle-tooltip');
                            this.setVehicleStatusAndColor(vm);
                        }
                    }
                } else {
                    this.liveMap.unbindToolTip(vm);
                }
            });
        }
    }

    getVehicleClass(vehicleMap: VehicleMap): string {
        switch (vehicleMap.status) {
            case 'to_plant':
                return 'vehicle-tooltip-to-plant';
            case 'to_job':
                return 'vehicle-tooltip-to-job';
            case 'on_job':
                return 'vehicle-tooltip-on-job';
            case 'loading':
                return 'vehicle-tooltip-loading';
            default:
                return 'vehicle-tooltip';
        }
    }

    onClusterModeChanged(event: MatSlideToggleChange) {
        this.clustered = event.checked;
        this.configurationService.updateConfiguration('general', ['live_map_vehicle_clustered'], [this.clustered]).then(() => {
        });
        if (this.clustered) {
            this.liveMap.hideVehicleMarkers();
            this.liveMap.showVehicleClusters();
        } else {
            this.liveMap.hideVehicleClusters();
            this.liveMap.showVehicleMarkers();
        }
    }

    vehicleFilter(event: any) {

        let text: string = (event.target) ? event.target.value : event.data;

        this.filterText = text;

        this.displayFilterVehicles();
    }

    rotateVehicleFilters(filterArray:IVehicleFilter[],currentValue:IVehicleFilter) : IVehicleFilter {

        let currentIndex = filterArray.findIndex(filter => filter.value === currentValue.value);
        let nextIndex = currentIndex + 1;

        if (nextIndex >= filterArray.length) {
            nextIndex = 0;
        }

        return filterArray[nextIndex]
    }

    handlePlantFilterChanged() {
        console.log("Plant Filter Changed");

        this.plantFilterValue = this.rotateVehicleFilters(this.plantFilterResource,this.plantFilterValue);
        this.displayFilterVehicles();

        console.log(this.plantFilterValue);
    }

    handleIgnitionFilterChanged() {
        this.ignitionFilterValue= this.rotateVehicleFilters(this.ignitionFilterResource,this.ignitionFilterValue);
        this.displayFilterVehicles();
    }

    displayFilterVehicles() {

        this.groupsByType.forEach(group => {

            group.dataSource.data = group.vehicles.filter((vehicleMap:VehicleMap) => {

                const isVehicleMatchedFilters: boolean = this.isVehicleMatchingFilters(vehicleMap);

                if(isVehicleMatchedFilters) {
                    if(vehicleMap.visible == false && vehicleMap.checked == true) {
                        this.liveMap.showVehicleMarker(vehicleMap);
                    }
                    return true;
                }else {
                    if(vehicleMap.visible == true){
                        this.liveMap.hideVehicleMarker(vehicleMap);
                    }
                    return false;
                }
            });
        });
    }

    isVehicleMatchingFilters(vehicleMap: VehicleMap): boolean {

        const vehicleHasLastPosition: boolean = this.vehicleHasLastPosition(vehicleMap);

        const isIgnitionFilterActive = this.ignitionFilterValue.value !== IGNITION_ON_OFF;
        const isPlantFilterActive = this.plantFilterValue.value !== PLANT_WITHOUT_FILTER;

        let ignitionFilterMatch: boolean;
        let plantFilterMatch: boolean;

        if (!vehicleHasLastPosition) {
            plantFilterMatch = isPlantFilterActive == false;
            ignitionFilterMatch = isIgnitionFilterActive == false;
        } else {
            ignitionFilterMatch = !isIgnitionFilterActive || Number(vehicleMap.vehicle.last_position['rmt.ign']) === this.ignitionFilterValue.value;
            plantFilterMatch = !isPlantFilterActive || Number(vehicleMap.vehicle.last_position['rmt.tripmarker']) === this.plantFilterValue.value;
        }

        if (this.hasFilterText()) {
            const textFilterMatch = this.textIsContained(vehicleMap.vehicle, this.filterText, ['name']);

            return ignitionFilterMatch && plantFilterMatch && textFilterMatch;
        } else {
            return ignitionFilterMatch && plantFilterMatch;
        }
    }

    hasFilterText() : boolean {
        return this.filterText != null && this.filterText != '';
    }

    vehicleHasLastPosition(vehicleMap: VehicleMap): boolean {
        const lastPosition = vehicleMap.vehicle.last_position;

        if (!lastPosition) {
            if (vehicleMap.visible) {
                this.liveMap.hideVehicleMarker(vehicleMap);
            }
            return false;
        } else {
            return true;
        }
    }

    textIsContained(resource: any, text: string, attributes: string[]): boolean {
        let contains = false;

        if (resource != null) {
            for (let attr of attributes) {
                if (resource[attr] != null && String(resource[attr]).toLowerCase().includes(text.toLowerCase())) {
                    contains = true;
                    break;
                }
            }
            return contains;
        }
    }

    organizeVehiclesWithTypes(vehicles: VehicleMap[]) {

        let mapping = {};
        this.groupsByType = [];

        vehicles.forEach(vm => {
            let typeId = vm.vehicle.type.id.toString();
            let typeKeylang = vm.vehicle.type.keylang;
            vm.checked = true;

            if (mapping[typeId] == null)
                mapping[typeId] = {
                    data: [],
                    keylang: typeKeylang,
                };
            mapping[typeId].data.push(vm);
        });

        for (let key in mapping) {
            let value = mapping[key];
            this.groupsByType.push(new VehicleMapGroup(value.data, value.keylang, Number(key)));
        }
    }

    ngAfterViewInit(): void {

        this.masterPanel.open();

        this.liveMap.onVehiclesDownloaded.subscribe(next => {
            if (next) {
                this.vehicles = next;
                this.organizeVehiclesWithTypes(this.vehicles);
                this.setVehiclesTooltip();
                this.onVehiclesMapDoneBuilding.emit(this.vehicles);
                if (!this.clustered) {
                    this.liveMap.hideVehicleClusters();
                    this.liveMap.showVehicleMarkers();
                }
            }
        });
        this.liveMap.onVehicleDataChanged.subscribe(next => {
            if (next) {
                this.vehicles[next.index] = next.data;

                this.displayFilterVehicles();
            }
        });
        this.liveMap.onVehicleMarkerClicked.subscribe((vehicleMap: VehicleMap) => {

            if (vehicleMap) {

                this.masterPanel.open();

                let el = document.getElementById(vehicleMap.vehicle.id);

                let group: VehicleMapGroup;

                for (let i = 0; i < this.groupsByType.length; i++) {
                    for (let j = 0; j < this.groupsByType[i].vehicles.length; j++) {
                        if (vehicleMap.vehicle.id == this.groupsByType[i].vehicles[j].vehicle.id) {
                            group = this.groupsByType[i];
                            break;
                        }
                    }
                }

                group.panel.open();

                setTimeout(() => {
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }, 600);

                vehicleMap.highlighted = true;

                setTimeout(() => {
                    vehicleMap.highlighted = false;
                }, 3000);
            }
        });
    }

    setVehicleStatusAndColor(vehicleMap: VehicleMap) {
        if (this.loopVehicleStatus == null || vehicleMap.vehicle == null) {
            return '';
        }
        const vehicleId = vehicleMap.vehicle.id;
        if (vehicleId != null) {
            const item = this.loopVehicleStatus.status.working.items[vehicleId];

            if (item != null) {
                const vehicleStatus = item.status;
                if (vehicleStatus != null) {
                    if (VEHICLES_STATUSES.hasOwnProperty(vehicleStatus.toUpperCase())) {
                        vehicleMap.color = VEHICLES_STATUSES[vehicleStatus.toUpperCase()].color;
                        vehicleMap.status = vehicleStatus;
                    }
                }
            } else {
                vehicleMap.color = VEHICLES_STATUSES.DEFAULT.color;
                vehicleMap.status = null;
            }
        }
    }
}
